<template>
  <v-menu offset-y close-on-content-click>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-sort</v-icon>
      </v-btn>
    </template>
    <v-list class="py-0">
      <v-list-item-group v-model="sorterName" color="primary">
        <template v-for="(item, i) in sortMenuOptions">
          <v-list-item :key="i" :value="item.value">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="i < sortMenuOptions.length - 1" :key="`${i}-divider`"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import {
  SORT_BY_ALPHABETIC_ASC,
  SORT_BY_ALPHABETIC_DESC,
  SORT_BY_DISPLAY_START_DESC,
  SORT_BY_DISPLAY_START_ASC,
  SORT_BY_CREATED_DESC,
  SORT_BY_CREATED_ASC,
  SORT_BY_UPDATED_DESC,
  SORT_BY_UPDATED_ASC,
} from '@/common/constants';
export default {
  name: 'SortMenu',
  props: {
    value: {
      type: String,
      default: SORT_BY_CREATED_DESC,
    },
    customSorter: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sorterName: this.customSorter || this.value,
      items: [
        { text: this.$t('sort.alpha'), value: SORT_BY_ALPHABETIC_ASC },
        { text: this.$t('sort.alphaDesc'), value: SORT_BY_ALPHABETIC_DESC },
        { text: this.$t('sort.startDateNewest'), value: SORT_BY_DISPLAY_START_DESC },
        { text: this.$t('sort.startDateOldest'), value: SORT_BY_DISPLAY_START_ASC },
        { text: this.$t('sort.createdDesc'), value: SORT_BY_CREATED_DESC },
        { text: this.$t('sort.createdAsc'), value: SORT_BY_CREATED_ASC },
        { text: this.$t('sort.updatedDesc'), value: SORT_BY_UPDATED_DESC },
        { text: this.$t('sort.updatedAsc'), value: SORT_BY_UPDATED_ASC },
      ],
    };
  },

  computed: {
    sortMenuOptions() {
      if (this.customSorter) {
        const valueToI18nKeyMap = {
          [SORT_BY_ALPHABETIC_ASC]: 'alpha',
          [SORT_BY_ALPHABETIC_DESC]: 'alphaDesc',
          [SORT_BY_DISPLAY_START_DESC]: 'startDateNewest',
          [SORT_BY_DISPLAY_START_ASC]: 'startDateOldest',
          [SORT_BY_CREATED_DESC]: 'createdDesc',
          [SORT_BY_CREATED_ASC]: 'createdAsc',
          [SORT_BY_UPDATED_DESC]: 'updatedDesc',
          [SORT_BY_UPDATED_ASC]: 'updatedAsc',
        };

        const i18nKey = valueToI18nKeyMap[this.customSorter] || this.customSorter;
        const customText = this.$t(`sort.${i18nKey}`);
        const defaultText = `Default (${customText})`;
        const filteredItems = this.items.filter((item) => item.value !== this.customSorter);
        return [{ text: defaultText, value: this.customSorter }, ...filteredItems];
      }
      return this.items;
    },
  },
  watch: {
    sorterName(newValue, prevValue) {
      this.$emit('input', newValue);
    },
    value(newValue) {
      this.sorterName = newValue;
    },
    customSorter(value) {
      if (value) this.sorterName = value;
    },
  },
};
</script>
<style scoped>
.sort-menu {
  height: 30px;
  width: 30px;
  z-index: 10000;
}
</style>
